import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppException } from '../../models/web/app-exception.model';
import { EdpApiService } from '../api/edp-api.service';
import { AuthService } from './auth.service';
import { MetaService } from './meta.service';

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

  constructor(
    private api: EdpApiService,
    private auth: AuthService,
    private meta: MetaService
  ) { }

  public logException(type: string, message: string, innerExceptionMessage: string = '', stackTrace: string = '', extraInformation: Object = null): Observable<any> {
    const appException: AppException = {
      facId: this.auth.getCurrentFacilityValue(),
      pharmId: this.auth.pharmacyId,
      userName: this.auth.username,
      source: `${this.meta.getAppName()} ${this.meta.getAppVersion()}`,
      type: type,
      message: message,
      innerExceptionMessage: innerExceptionMessage,
      stackTrace: stackTrace,
      extraInformation: extraInformation && typeof extraInformation === 'object' ? JSON.stringify(extraInformation) : null
    };
    // TODO: use correct endpoint when available
    return this.api.put<AppException>('/exceptions/logexception', appException);
  }

  public getServiceError(error: any, baseMessage?: string): string {
    try {
      let msg: string = baseMessage ? baseMessage : '';
      const serviceError: string = error.json().message;
      if (serviceError && serviceError.length > 0) {
        msg = `${msg} Error: ${serviceError}`;
      }
      return msg;
    } catch (e) {
      return null;
    }
  }
}
